import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { MemberService } from '../../services/memberService'
@Component({
  selector: 'app-detail-history',
  templateUrl: './detail-history.component.html',
  styleUrls: ['./detail-history.component.css']
})
export class DetailHistoryComponent implements OnInit {

  itemsDetail:any [];
  constructor(private _location: Location, private route: ActivatedRoute,private mem:MemberService) { }

  ngOnInit() {
    let idItem = this.route.snapshot.params['id'];
    this.itemsDetail = this.mem.getItemHistory(idItem)
    console.log(this.itemsDetail)
  }
  backClicked() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-history/detail-history.component.ts